import React from "react";
import ButtonComponent from "../../../atoms/button";
import ImageTile from "../../../atoms/imageTile";
import { ADDED_TO_CART, INCLUSIVE_OF_ALL_TAXES, ITEM, S } from "../../../../constants/common/common";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { updateCurrency } from "../../../../utils/common";
import dynamic from "next/dynamic";
const PriceBreakUp = dynamic(() => import("./priceBreakUp"), {
  ssr: false,
});

/**
 * Component that renders the footer for the mobile layout, displaying
 * the total add-on count and total price, and handling the continuation of the process.
 *
 * @param {Object} props - The component props.
 * @param {function} props.calculateAddonCount - Function to calculate the count of add-ons.
 * @param {number} props.selectedAddonCount - The count of currently selected add-ons.
 * @param {number} props.totalPrice - The total price of the items, including add-ons.
 * @param {function} props.onContinueClick - Function to handle the continuation action.
 */
const MobileFooter = ({ calculateAddonCount, selectedAddonCount, totalPrice, onContinueClick }) => {
  const selectedCurrency = useSelector((state) => state?.currencyList?.userSelectedCurrency);

  return (
    <div className="fixed bottom-0 flex w-full flex-col bg-white-900 shadow-top">
      {calculateAddonCount() > 0 && (
        <div className="flex h-[32px] w-full items-center justify-center gap-2 bg-[#E0ECFF] px-4">
          <ImageTile
            imgSrc="/icons/Item added.svg"
            imgHeight={22}
            imgWidth={22}
            imgAlt="trash-icon"
            imgClass="cursor-pointer w-[20px] h-[20px] shrink-0 m-[8px]"
            isAdjustWidth={true}
          />
          <span className="text-12 font-500 text-fnp-500">
            {calculateAddonCount()} {ITEM}
            {selectedAddonCount !== 1 ? S : ""} {ADDED_TO_CART}
          </span>
        </div>
      )}

      <div className="bg-white flex w-full items-center justify-between gap-4 border-t border-[#F5F5F5] px-[16px] ">
        <div className="flex w-[360px] items-center gap-[8px] py-[12px]">
          <div className="flex flex-col gap-[2px]">
            <span className="block text-[17px] font-bold leading-[20px] text-[#333333]">
              {updateCurrency(selectedCurrency, totalPrice)}
            </span>
            <PriceBreakUp />

            <span className="block font-inter text-[12px] font-medium leading-[16.8px] text-[#757575]">
              {INCLUSIVE_OF_ALL_TAXES}
            </span>
          </div>
        </div>

        <ButtonComponent
          onClick={onContinueClick}
          buttonVariant="filled"
          classes="text-fnp-300 border border-green-100 py-12 px-32 text-16"
          label={"Continue"}
          size=""
          btnParentClasses="justify-end"
          labelStyle="text-16 font-600"
        />
      </div>
    </div>
  );
};

MobileFooter.propTypes = {
  calculateAddonCount: PropTypes.func.isRequired,
  selectedAddonCount: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  onContinueClick: PropTypes.func.isRequired,
};

export default MobileFooter;
